import { FormGroup, Label } from "reactstrap";
import FEATURE_COLORS from "../constants/FeatureColors";

const FeatureCheckbox = ({ name, checked, setChecked, disabled }) => {
  return (
    <div className="row py-2 h-100">
      {/* <Spinner color={FEATURE_COLORS.bootstrapColor[name.toLowerCase()]} /> */}
      <FormGroup
        check
        inline
        disabled={disabled}
        style={{ cursor: "default" }}
        className={`d-flex flex-column text-center`}
      >
        <input
          type="checkbox"
          defaultChecked={checked}
          style={{ cursor: "pointer" }}
          onClick={(e) => setChecked(e.target.checked)}
        />
        <Label
          className={`bg-transparent text-${
            FEATURE_COLORS.bootstrapColor[name.toLowerCase()]
          }`}
        >
          {name}
        </Label>
      </FormGroup>
    </div>
  );
};

export default FeatureCheckbox;
